import { createReducer, on } from "@ngrx/store";
import { DatosPlanes } from "../../Models/datosPlanes";
import { loadPlanes, updateDatosPlanes, updatePlanes } from "./planes.action";

export interface PlanesState {
    data: DatosPlanes | null;
    error: string;
}

export const initialState: PlanesState = {
    data: {
        lead_id: '',
        planes: {
            data: {
                products: [
                    {
                        coveragesGroup: [
                            {
                                Name: '',
                                Include: false,
                                Description: ''
                            }
                        ],
                        coverages: [
                            {
                                price: 0,
                                description: '',
                                name: ''
                            }
                        ],
                        order: 1,
                        code: '',
                        priceMensual: {
                            currency: '',
                            amount: 0,
                            formatted: ''
                        },
                        priceAnual: {
                            currency: '',
                            amount: 0,
                            formatted: ''
                        },
                        name: ''
                    }
                ]
            },
            FalloTarifaEsencialMotos: false,
            FalloTarifaTotalMotos: false
        },
        payment_frequency: '',
        selected_plan: '',
        coberturasOpcionales: []
    },
    error: ''
}

export const planesReducer = createReducer(initialState,
    on(loadPlanes, (state, { data }) => ({ ...state, data })),
    on(updatePlanes, (state, { lplans }) => ({ ...state, data: state.data ? { ...state.data, planes: lplans } : state.data })),
    on(updateDatosPlanes, (state, { upDatos }) => ({ ...state, data: upDatos ? upDatos : state.data }))
)